export default {
  gutterBottom: {
    marginBottom:'0 !important'
  }
};
